import {PixelsPerPoint, Dependencies} from 'services/screen';

export function dpiOf(di: Dependencies = {}): PixelsPerPoint {
  const {wndw = window} = di;
  return wndw.devicePixelRatio || 1;
}
